import { createSignal } from "solid-js";
import { useAppUI } from "../../../layouts/minimal/AppUIContext";
import type { InteractionMode } from "../../../layouts/minimal/AppUIContext";
import type { ModeType } from "../../PromptBar.types";
import { generatePlaceholderText } from "../utils";

/**
 * Hook for managing prompt mode state (chat/agent/workflow)
 */
export const usePromptMode = () => {
  const ui = useAppUI();
  const [selectedMode, setSelectedMode] = createSignal<ModeType>("agent");

  const placeholderText = () => generatePlaceholderText(selectedMode());

  const handleModeChange = (mode: ModeType) => {
    setSelectedMode(mode);
    ui.actions.setInteractionMode(mode as InteractionMode);
  };

  return {
    selectedMode,
    setSelectedMode: handleModeChange,
    placeholderText,
  };
};
